<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <h4>{{ user.name }}'s Assigned Roles</h4>
                <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <div v-if="user.type === 'admin'" class="w-100 text-end">
                            <v-btn color="black" density="compact" text="Assign Role"
                                   @click="subDialogSwitch = true"/>
                        </div>
                        <v-table>
                            <thead>
                            <tr>
                                <th>Role</th>
                                <th>API Key</th>
                                <th>Portal</th>
                                <th>Company</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="role in roles" v-if="roles && roles.length" :key="role.id" class="text-left">
                                <td>{{ capitalize(role.title) }}</td>
                                <td>{{ role.api_key }}</td>
                                <td>{{ capitalize(role.portal_name ?? '') }}</td>
                                <td>{{ capitalize(role.company_name ?? '') }}</td>
                                <td>{{ formatDateTime(role.created_at) }}</td>
                                <td>
                                    <v-btn-group density="compact" divided variant="outlined">
                                        <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                               @click="unAssignRole(role)">Delete
                                        </v-btn>
                                    </v-btn-group>
                                </td>
                            </tr>
                            <tr v-else>
                                <td v-if="!roles" class="text-center" colspan="6">
                                    <v-progress-circular color="primary" indeterminate size="small"/>
                                </td>
                                <td v-else class="text-center" colspan="6">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn size="small" type="button"
                       @click="$emit('update:modelValue',false)">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <assign-portal v-if="subDialogSwitch" v-model="subDialogSwitch" :user="user"/>
</template>

<script setup>
import {ref, onMounted, capitalize, watch} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import AssignPortal from "@/components/dialogs/users/AssignRole.vue";
import {formatDateTime} from "@/composables/useTimezone";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    user: Object,
});

const emits = defineEmits(['update:modelValue']);
const dialogSwitch = ref(props.modelValue);
const subDialogSwitch = ref(false);
const roles = ref(null);
const errors = ref([]);

onMounted(() => {
    fetchRoles()
})

watch(() => subDialogSwitch.value, (newState) => {
    if (!newState) {
        fetchRoles()
    }
})
const fetchRoles = () => {
    errors.value = [];
    send('post', `admin/user-roles/${props.user.id}`)
        .then((response) => {
            roles.value = response.data.data;
        })
        .catch(function (errorResponse) {
            snackbar.showSnackbar(errorResponse ?? 'Something went wrong', 'error');
        })
}

const unAssignRole = (role) => {
    errors.value = [];
    if (confirm(`Are you sure you want to un assign this role?`)) {
        send('post', `admin/unassign-roles`, {
            user_id: props.user.id,
            role_id: role.role_id,
            company_id: role.company_id
        })
            .then((response) => {
                snackbar.showSnackbar(response.data.message);
                fetchRoles();
            })
            .catch(function (errorResponse) {
                if (errorResponse.response.data.errors) {
                    let validationErrors = errorResponse.response.data.errors;
                    Object.keys(validationErrors).forEach((key) => {
                        errors.value.push(validationErrors[key][0]);
                    });
                } else if (errorResponse.response.data.message) {
                    errors.value.push(errorResponse.response.data.message);
                }
                snackbar.showSnackbar('Something went wrong', 'error');
            })
    }
}
</script>
